import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-appid-1027-2",
  "use": "icon-appid-1027-2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-appid-1027-2\">\n  <path d=\"M17.0834 5.8332L10 1.66666L2.91669 5.8332V14.1666L10 18.3333L17.0834 14.1666V5.8332Z\" fill=\"#BDC9F2\" stroke=\"#BDC9F2\" stroke-width=\"0.833333\" stroke-linejoin=\"round\" />\n  <path d=\"M12.2 6H9.2L8 11.175H9.6L8.8 15L14 8.7H11.6L12.2 6Z\" fill=\"#3859B0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol